/* Product-page vehicle confirmation. Uses only the selected variant's records. */
(function () {
  'use strict';
  const core = window.JSDieselFitment;
  const vehicle = window.JSSVehicle;
  if (!core || !vehicle || customElements.get('jss-vehicle-check')) return;
  const labels = { make: 'make', year: 'year', model: 'model', engine: 'engine size', type: 'engine type / code', body: 'body style' };
  const vehicleLabel = values => ['make', 'year', 'model', 'engine', 'type', 'body'].map(k => values[k]).filter(Boolean).join(' ');
  function sectionFor(id) {
    return [...document.querySelectorAll('jss-product-fitment')].find(el => el.dataset.productId === id);
  }
  class VehicleCheck extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.card = this.querySelector('[data-check-card]');
      this.heading = this.querySelector('[data-check-heading]');
      this.detail = this.querySelector('[data-check-detail]');
      this.label = this.querySelector('[data-check-vehicle]');
      this.notes = this.querySelector('[data-check-notes]');
      this.icon = this.querySelector('[data-check-icon]');
      this.change = this.querySelector('[data-change-vehicle]');
      this.view = this.querySelector('[data-view-fitment]');
      if (!this.card) return;
      this.change.addEventListener('click', () => this.openDialog(this.change), opts);
      this.view.addEventListener('click', () => {
        const section = sectionFor(this.dataset.productId);
        if (!section) return;
        const heading = section.querySelector('h2');
        if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
        section.style.scrollMarginTop = '16px';
        section.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }, opts);
      window.addEventListener('jss:vehicle-change', () => {
        this.refresh();
        // Keep reload/back links consistent with a vehicle changed on this page.
        try { history.replaceState(history.state, '', vehicle.withVehicle(location.href)); } catch (_) { /* The check still works without History API. */ }
      }, opts);
      document.addEventListener('jss:fitment-update', event => {
        if (event.detail?.productId === this.dataset.productId) this.refresh();
      }, opts);
      this.refresh();
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
    openDialog(trigger) {
      document.querySelector('jss-vehicle-panel')?.open(trigger, this);
    }
    show(status, heading, detail, notes = []) {
      this.card.dataset.state = status;
      this.heading.textContent = heading;
      this.detail.textContent = detail;
      this.icon.textContent = status === 'match' ? '✓' : status === 'loading' ? '…' : status === 'unlisted' ? '!' : '?';
      this.notes.replaceChildren(...notes.map(note => { const li = document.createElement('li'); li.textContent = note; return li; }));
      this.notes.hidden = notes.length === 0;
      this.currentState = { status, heading, detail };
      this.dispatchEvent(new CustomEvent('jss:vehicle-check-update', { bubbles: true, detail: { productId: this.dataset.productId } }));
    }
    refresh() {
      const record = vehicle.get();
      const source = sectionFor(this.dataset.productId);
      const state = source?.currentState;
      this.view.hidden = !source;
      this.label.hidden = !record;
      this.label.textContent = record ? vehicleLabel(record.values) : '';
      this.change.textContent = record ? 'Change vehicle' : 'Choose vehicle';
      const currentData = state?.data && !state.loading && !state.invalid && !state.error && String(state.data.id) === String(source.selectedId());
      if (currentData && state.data.fitmentClass === 'universal') return this.show('universal', 'Universal parts', 'Check product dimensions and installation requirements before ordering.');
      if (!record) return this.show('select', 'Does this fit your vehicle?', 'Choose your vehicle to check the selected product option.');
      if (state?.loading || (state?.data && String(state.data.id) !== String(source.selectedId()))) return this.show('loading', 'Checking this product option…', 'Please wait while we check your selected vehicle.');
      if (state?.invalid) return this.show('unknown', 'Select a product option', 'Choose an available combination of product options to check fitment.');
      const selectionMissing = core.vehicleKeys.filter(k => !record.values[k]);
      if (selectionMissing.length) return this.show('incomplete', 'Complete your vehicle details', 'Add your ' + selectionMissing.map(k => labels[k]).join(', ') + ' to check this product option.');
      if (!core.vehicleKeys.every(k => record.confirmedKeys.includes(k))) {
        this.change.textContent = 'Confirm vehicle';
        return this.show('confirm', 'Confirm your vehicle details', 'Review the vehicle shown above and confirm it to check this product option.');
      }
      if (!state?.data || state.error) return this.show('unknown', 'Fitment not confirmed', 'We cannot confirm this option for your vehicle. Call 604 953 9890 before ordering.');
      const result = core.checkVehicle(state.data.applications, record.values);
      const option = state.data.title && state.data.title !== 'Default Title' ? 'Selected option: ' + state.data.title + '. ' : '';
      if (result.status === 'match') return this.show('match', 'This product fits your vehicle', option + 'Your vehicle matches the verified application for this option.');
      if (result.status === 'restricted') return this.show('restricted', 'Vehicle details match. Check restrictions.', option + 'Confirm the requirements below before ordering.', result.notes);
      if (result.status === 'incomplete') return this.show('incomplete', 'More vehicle details needed', option + 'Add your ' + result.missing.map(k => labels[k]).join(', ') + ' to check this option.');
      if (result.status === 'unlisted') return this.show('unlisted', 'No listed fit for this option', option + 'Your vehicle is not listed in this option’s verified applications. Check another option or call 604 953 9890.');
      return this.show('unknown', 'Fitment not confirmed', option + 'Verified fitment information is not available for this option. Call 604 953 9890 before ordering.');
    }
  }
  customElements.define('jss-vehicle-check', VehicleCheck);
  if (!customElements.get('jss-vehicle-summary')) customElements.define('jss-vehicle-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.querySelector('button').addEventListener('click', event => {
        const check = [...document.querySelectorAll('jss-vehicle-check')].find(el => el.dataset.productId === this.dataset.productId);
        check?.openDialog(event.currentTarget);
      }, opts);
      window.addEventListener('jss:vehicle-change', () => this.refresh(), opts);
      document.addEventListener('jss:vehicle-check-update', event => {
        if (event.detail?.productId === this.dataset.productId) this.refresh();
      }, opts);
      this.refresh();
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
    refresh() {
      const record = vehicle.get();
      const check = [...document.querySelectorAll('jss-vehicle-check')].find(el => el.dataset.productId === this.dataset.productId);
      const state = check?.currentState;
      const status = state?.status || 'loading';
      // Keep Change vehicle available even when this option has no match.
      // A restricted result still has a verified vehicle match; its notes stay
      // visible in the detailed fitment check below the purchase controls.
      // The empty state opens the same selector as Change vehicle.
      this.hidden = !check;
      this.querySelector('[data-vehicle-summary-action]').textContent = record ? 'Change vehicle' : 'Add Your Vehicle';
      this.querySelector('[data-add-vehicle-icon]').toggleAttribute('hidden', !!record);
      const badge = this.querySelector('.jss-vehicle-summary__badge');
      this.dataset.state = status;
      const universal = status === 'universal';
      badge.hidden = !universal && (!record || !['match', 'restricted'].includes(status));
      badge.textContent = universal ? 'Universal parts' : 'Fits your vehicle';
      const note = status === 'restricted' ? '. Check fitment notes below.' : '';
      badge.title = universal ? 'Check product dimensions and installation requirements.' : (!badge.hidden ? vehicleLabel(record.values) + note : '');
      badge.setAttribute('aria-label', badge.textContent + note);
    }
  });
})();
